export const CZECH_WORK_OPPORTUNITY = {
  title: "Чех Улс руу ажиллах 10 нээлттэй байр",
  jobType: "Хүнсний үйлдвэр",
  registrationDeadline: "10 сарын 5 хүртэл",
  departureTarget: "6–8 сарын дотор явах зорилтот төлөв",
  positions: {
    total: 10,
    women: "6 эмэгтэй орон тоо",
    families: "2 гэр бүл хамт бүртгүүлэх боломжтой",
  },
  payments: [
    {
      label: "Гэрээ байгуулах үед",
      amount: "€1,700",
      note: "Эхний төлбөр",
    },
    {
      label: "Визэнд орохоос өмнө",
      amount: "€765",
      note: "Даатгал, визийн улсын хураамж багтсан",
    },
  ],
  eligibility: [
    "45 хүртэлх насны байх",
    "Эрүүгийн асуудалгүй, шаардлагатай албан лавлагаа гаргах боломжтой байх",
    "Европын холбооны улсад хууль бусаар оршин сууж байгаагүй байх",
    "Ажлын байрны эцсийн шалгуур, ярилцлагын нөхцөлийг хангасан байх",
  ],
  firstMaterial: "Хүчинтэй гадаад паспорт",
  materialNote:
    "Эхний шатанд таны үндсэн материал нь гадаад паспорт байна. Банкны баталгаа, барьцаа шаардахгүй.",
  timeline: [
    ["01", "Урьдчилсан нягтлал", "Нас, иргэний нөхцөл, хууль бус оршин суусан эсэх болон ажлын байрны шалгуурыг нягтална."],
    ["02", "Гэрээ ба ажил олгогчийн материал", "Гэрээ байгуулж, ажлын байр болон ажил олгогчийн баримтыг процессын дагуу бэлтгэнэ."],
    ["03", "Employee Card өргөдөл", "Визийн цаг, албан ёсны анкет, орчуулга болон шаардлагатай баримтаа бүрдүүлж мэдүүлнэ."],
    ["04", "Явах бэлтгэл", "Зөвшөөрөл гарсны дараа даатгал, нислэг, очих бэлтгэлээ зохион байгуулна."],
  ],
  benefits: [
    {
      title: "Урт хугацаанд ажиллах боломж",
      description:
        "Employee Card нь дээд тал нь 2 жилээр олгогддог; ажлын болон оршин суух нөхцөл үргэлжилбэл хугацаа дуусахаас өмнө сунгалт хүсэх боломжтой.",
    },
    {
      title: "Шенгений орнуудаар зорчих",
      description:
        "Хүчинтэй Employee Card-тай бол Шенгений бүсэд ажлын бус зорилгоор 180 хоногт нийт 90 хүртэл хоног зорчих эрхтэй.",
    },
    {
      title: "Гэр бүлийн боломж",
      description:
        "Гэр бүлээ татах өргөдөл гаргах боломжтой. Эрх, хугацаа нь таны оршин суух үндэслэл болон тухайн үеийн албан шаардлагаар нягтлагдана.",
    },
    {
      title: "Хүүхдийн боловсрол",
      description:
        "Гэр бүлээрээ оршин суух зөвшөөрөлтэй болсон тохиолдолд хүүхдийн сургуулийн асуудлыг тухайн хот, оршин суух үндэслэл болон журамд нийцүүлэн зохицуулна.",
    },
    {
      title: "Монгол–Чех хооронд зорчих",
      description:
        "Хүчинтэй оршин суух зөвшөөрлийн хугацаанд Чехээс гарч, буцан нэвтрэх боломжтой.",
    },
    {
      title: "Тогтвортой амьдрах орчин",
      description:
        "Европын төвд байрлах, цэвэр цэмцгэр, аюулгүй амьдрах орчныг зорьж буй хүмүүст тохирох сонголт.",
    },
  ],
} as const;

export const CZECH_WORK_HERO = "https://files.manuscdn.com/user_upload_by_module/session_file/310519663375899735/WKntKAFCgKfDFJMT.jpg";

export const CZECH_WORK_CONTACT = {
  phoneDisplay: "9507-5552",
  phoneHref: "tel:+97695075552",
  address: "СУИС-ийн урд Gem Castle төв 9 давхарт 907 тоот",
  officeHours: "Даваа–Баасан 09:00–18:00 · Ням 13:00–17:00",
} as const;
